import React, { useState } from "react";
import CreatableSelect from "react-select/creatable";
import "../styles/Pantry.css";
import ingredients from "../data/ingredients";

interface IngredientSearchProps {
  onAddIngredient: (ingredient: { label: string; value: string }) => void;
}

const IngredientSearch: React.FC<IngredientSearchProps> = ({
  onAddIngredient,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);

  const options = ingredients.map((ingredient) => ({
    label: ingredient.name,
    value: ingredient.name.toLowerCase(),
  }));

  const handleChange = (selected: any) => {
    if (selected) {
      const newIngredient = {
        label: selected.label || selected,
        value: selected.value || selected,
      };
      onAddIngredient(newIngredient);
      setSelectedOption(null);
      setInputValue("");
    }
  };

  // ✅ Sama tyyli kuin MealSearchissa
  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      backgroundColor: "#424242EB",
      borderColor: "#424242EB",
      borderWidth: "2px",
      borderRadius: "5px",
      fontSize: "16px",
      minHeight: "40px",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#a5f865",
      },
    }),
    placeholder: (provided: any) => ({
      ...provided,
      color: "#a5f865",
      paddingLeft: "2px",
    }),
    input: (provided: any) => ({
      ...provided,
      color: "#a5f865", // ✅ kirjoitettava teksti vihreäksi
    }),
    singleValue: (provided: any) => ({
      ...provided,
      color: "#a5f865",
      paddingLeft: "12px",
    }),
    menu: (provided: any) => ({
      ...provided,
      backgroundColor: "#424242",
      zIndex: 10,
      borderRadius: "5px",
      overflow: "hidden",
      marginTop: 2,
    }),
    menuList: (provided: any) => ({
      ...provided,
      paddingTop: 0,
      paddingBottom: 0,
      backgroundColor: "#424242",
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#303030" : "#424242",
      color: "#a5f865",
      fontSize: "14px",
      display: "flex",
      alignItems: "center",
      width: "100%",
      padding: "10px 12px",
    }),
  };

  return (
    <CreatableSelect
      options={options}
      value={selectedOption}
      inputValue={inputValue}
      onInputChange={(value) => setInputValue(value)}
      onChange={handleChange}
      classNamePrefix="react-select"
      isClearable
      isSearchable
      placeholder="Lisää raaka-aineita..."
      formatCreateLabel={(inputValue) => `Lisää "${inputValue}"`}
      styles={customStyles} // ✅ tyylit lisätty
    />
  );
};

export default IngredientSearch;
